import { render, staticRenderFns } from "./AdminDomains.vue?vue&type=template&id=61a4c982&scoped=true"
import script from "./AdminDomains.vue?vue&type=script&lang=ts"
export * from "./AdminDomains.vue?vue&type=script&lang=ts"
import style0 from "./AdminDomains.vue?vue&type=style&index=0&id=61a4c982&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a4c982",
  null
  
)

export default component.exports